import { TitleOrder } from '@mantine/core';
import { ThemeIcon } from '@zorro/design-system/v2/ThemeIcon';
import { Title, TitleProps } from '@zorro/design-system/v2/Title';
import { Box, Stack } from '@zorro/web/design-system';
import { ReactNode } from 'react';

type Props = {
  title: string;
  icon: ReactNode;
  bgIcon?: string;
  titleOrder?: TitleOrder;
  gap?: string;
  titleProps?: TitleProps;
};

export const ModalTitle = ({
  title,
  icon,
  bgIcon,
  titleOrder = 1,
  titleProps,
  gap = 'sm',
}: Props) => {
  return (
    <Stack mt="sm" align="left" justify="center" gap={gap}>
      {bgIcon ? (
        <ThemeIcon bg={bgIcon} size="32">
          {icon}
        </ThemeIcon>
      ) : (
        <Box>{icon}</Box>
      )}
      <Title size="md" order={titleOrder} {...titleProps}>
        {title}
      </Title>
    </Stack>
  );
};
